import React, { useState, createContext } from 'react';
//import MultiStepForm from './MultiStepForm'

const CurrentContext = React.createContext({
    current: 0,
    setCurrent: () => {}
})

export default CurrentContext;
